import { Box, Typography } from '@material-ui/core'
import { useEffect, useState } from 'react'
import Api from '../../../Apis/api.service'
import useStyles from '../styles'
import InfoWrapper from './InfoWrapper'

const ParentWrapper = ({ record }) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <div className={classes.beginBar}></div>
      <Typography classeName={classes.title} gutterBottom>
        Dossier parent
      </Typography>
      <InfoWrapper title="Numero" value={record.ticket_id} />
      <InfoWrapper title="Code Copro" value={record.copro_code} />
      <InfoWrapper title="Libellé" value={record.libelle} />
      <InfoWrapper title="Etat" value={record.status} />
    </div>
  )
}
export default ParentWrapper
